import type React from "react";
import { BrowserRouter } from "react-router";

export function RouterProvider({ children }: { children: React.ReactNode }) {
	return <BrowserRouter>{children}</BrowserRouter>;
}
